import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'rolDePersonal' // nombre del pipe en las directivas
})

export class RolDeUsuarioPipe implements PipeTransform{
    // Métdodo a implementar siempre
    transform(listaPersonal:Array<any>, rolDeUsuario:string){

        // Checa si el rolDeUsuario seleccionado es "Todos", devuelve todo el personal
        if(rolDeUsuario == "Todos"){
            return listaPersonal;
        }

        // Arreglo para almacenar al personal que pertenece al depto seleccionado
        let personalDeRol:Array<any> = [];

        // Ciclo para recorrer el listado e ir incorporándolo a la lista nueva
        for (let index in listaPersonal){
            let persona:any = listaPersonal[index];
            if(persona.informacionDelSistema !=null)
            {
                if( persona.informacionDelSistema.rolDeUsuario == rolDeUsuario){
                    personalDeRol.push(persona);
                }
            }

        }
        return personalDeRol;
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/roles-personal.pipe.ts